import React from 'react';
import { Col, Row } from 'antd';
import Checkbox from 'antd/lib/checkbox';

import style from './CustomCheckBox.module.scss';


export const CustomCheckBox = props => {
  const { value, title, ...extraProps } = props;


  return (
    <Row>
      <Col span={ 2 }>
        <Checkbox checked={ value } { ...extraProps } />
      </Col>
      <Col span={ 22 }>
        <h4 className={ style.title }>{title}</h4>
      </Col>

    </Row>
  );
};


